const RECENTLY_VIEWED_KEY = 'liftmarket_recently_viewed';
const RECENTLY_VIEWED_MAX = 5;

function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
}

function addRecentlyViewed(item) {
  if (!item || !item.id) return;
  try {
    const current = getRecentlyViewed();
    const filtered = current.filter(i => i.id !== item.id);
    const slim = {
      id: item.id,
      name: item.name,
      type: item.type,
      brand: item.brand,
      price: item.price,
      image_url: item.image_url,
      capacity: item.capacity,
      condition: item.condition,
    };
    const updated = [slim, ...filtered].slice(0, RECENTLY_VIEWED_MAX);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
  } catch (e) {}
}

/* ─── Analytics (GA4) ────────────────────────────────────────── */
function trackEvent(name, params) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  } catch (e) {}
}

function trackPageview(path, tab) {
  try {
    if (typeof window.gtag === 'function' && window.__GA_ID__) {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_title: tab ? 'LiftMarket — ' + tab : document.title,
        page_location: window.location.origin + path,
      });
    }
  } catch (e) {}
}

/* ─── Utilities ──────────────────────────────────────────────── */
function formatPrice(n) {
  if (n == null || Number(n) === 0) return 'Contact for Pricing';
  return '$' + Number(n).toLocaleString('en-US');
}

function typeLabel(t) {
  const map = {
    forklift: 'Forklift',
    pallet_jack: 'Pallet Jack',
    reach_truck: 'Reach Truck',
    telehandler: 'Telehandler',
  };
  return map[t] || t;
}

function conditionClass(c) {
  if (!c) return '';
  if (c === 'Factory New') return 'cond-new';
  if (c === 'CPO') return 'cond-cpo';
  if (c === 'Used - Excellent') return 'cond-excellent';
  if (c === 'Used - Good') return 'cond-good';
  return 'cond-fair';
}

function placeholderImg(type, id) {
  const colors = { forklift: ['2a2a2a','fc9430'], pallet_jack: ['1e2020','e98520'], reach_truck: ['1a1f1a','adaaaa'], telehandler: ['202020','767575'] };
  const [bg, fg] = colors[type] || ['2a2a2a','adaaaa'];
  const label = typeLabel(type);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="180" viewBox="0 0 200 180"><rect fill="#${bg}" width="200" height="180"/><text x="100" y="96" text-anchor="middle" font-family="sans-serif" font-size="14" fill="#${fg}">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

function handleImgError(e, type) {
  e.target.onerror = null;
  e.target.src = placeholderImg(type);
}

/* ─── API helpers ────────────────────────────────────────────── */
async function apiFetch(path, options = {}, token = null) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch('/api' + path, {
    ...options,
    headers,
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Request failed');
  return json;
}

export {
  RECENTLY_VIEWED_KEY,
  RECENTLY_VIEWED_MAX,
  getRecentlyViewed,
  addRecentlyViewed,
  trackEvent,
  trackPageview,
  formatPrice,
  typeLabel,
  conditionClass,
  placeholderImg,
  handleImgError,
  apiFetch,
};
